import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../store';
import { setUserPersonaFilter } from '../../../../store/benchmark/slice';
import TextInput from '../../../../components/UI/TextInput/TextInput';

const UserPersonaFilter: React.FC = () => {
  const dispatch = useDispatch();
  const userPersona = useSelector((state: RootState) => state.benchmark.filters.user_persona) || '';

  const handleChange = (value: string) => {
    dispatch(setUserPersonaFilter(value || undefined));
  };

  return (
    <TextInput
      label="User Persona"
      value={userPersona}
      onChange={handleChange}
      placeholder="Filter by user persona"
    />
  );
};

export default UserPersonaFilter;
